import React, { useEffect } from 'react';
import { auth } from '../../firebase/firebase-config';
import { markDocumentAsRead } from '../../services/documentsService';
import ContentAttachmentsActions from '../../platform/ContentAttachmentsActions';
import ContentDetailHero from '../../platform/ContentDetailHero';
import ContentPdfEmbed from '../../platform/ContentPdfEmbed';
import ContentUnitTag from '../common/ContentUnitTag';
import { normalizeAttachments } from '../../platform/contentAttachments';
import {
  isDetailHeroEnabled,
  PREMIUM_MODULE_IDS,
  premiumDetailClassName,
} from '../../platform/contentListVisual';

function formatDate(date) {
  if (!date) return '';
  const value = date instanceof Date ? date : new Date(date);
  return value.toLocaleString('sl-SI', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function DocumentDetail({ document, unitNames = {} }) {
  const useHero = isDetailHeroEnabled(PREMIUM_MODULE_IDS.DOCUMENTS);

  useEffect(() => {
    const markAsRead = async () => {
      if (auth.currentUser?.uid) {
        await markDocumentAsRead(auth.currentUser.uid, document.id);
      }
    };

    markAsRead();
  }, [document.id]);

  const hasPdfAttachments = normalizeAttachments(document).length > 0;

  const meta = (
    <>
      <span>Ustvaril {document.displayName || 'Anonimen'}</span>
      {document.createdAt && (
        <>
          <span className="platform-content-detail-hero__meta-separator">·</span>
          <span>{formatDate(document.createdAt)}</span>
        </>
      )}
    </>
  );

  return (
    <article className={premiumDetailClassName(PREMIUM_MODULE_IDS.DOCUMENTS, 'document-detail platform-content-detail')}>
      <div className="platform-content-detail-shell">
        {useHero ? (
          <ContentDetailHero
            title={document.title}
            badges={<ContentUnitTag item={document} unitNames={unitNames} />}
            meta={meta}
            variant="document"
          />
        ) : null}

        <div className="platform-content-detail-card">
          {!useHero && (
            <div className="platform-content-detail-card__header">
              <h2 className="platform-content-detail-card__title">{document.title}</h2>
            </div>
          )}

          <div className="platform-content-detail__body">
            {!useHero && (
              <div className="platform-content-detail__meta">
                <ContentUnitTag item={document} unitNames={unitNames} />
                <span className="platform-content-detail__meta-separator">·</span>
                <span>Ustvaril {document.displayName || 'Anonimen'}</span>
                {document.createdAt && (
                  <>
                    <span className="platform-content-detail__meta-separator">·</span>
                    <span>{formatDate(document.createdAt)}</span>
                  </>
                )}
              </div>
            )}

            {document.description && (
              <div className="platform-content-detail__content">
                <p className="document-detail__description">{document.description}</p>
              </div>
            )}

            <ContentAttachmentsActions item={document} className="platform-content-detail__actions" />
          </div>
        </div>

        {hasPdfAttachments && (
          <ContentPdfEmbed item={document} title="Dokument" />
        )}
      </div>
    </article>
  );
}

export default DocumentDetail;
